// extracted by mini-css-extract-plugin
export default {"header":"rS-z","logo":"sS-z","signin":"tS-z"};